import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";
import { MapPin, Download, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const DestinationCard = ({ country, index, onRemove, calculateProgress }) => {
  const navigate = useNavigate();
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadPdf = async (e) => {
    e.stopPropagation(); setIsDownloading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/export/${country.country_id}/${country.visa_id.split('_')[1]}/pdf`, { credentials: "include" });
      if (!res.ok) throw new Error("Export failed");
      const blob = await res.blob(); const url = window.URL.createObjectURL(blob); const a = document.createElement("a");
      a.href = url; a.download = `${country.country_id}_roadmap.pdf`; document.body.appendChild(a); a.click(); a.remove();
      toast.success("PDF downloaded!");
    } catch (error) { toast.error("Download failed"); } finally { setIsDownloading(false); }
  };

  return (
    <Card className="border-border/50 hover:shadow-md transition-all overflow-hidden">
      {country.image_url && (<div className="h-32 overflow-hidden"><img src={country.image_url} alt={country.country_name} className="w-full h-full object-cover" /></div>)}
      <CardContent className="p-4">
        <div className="flex items-start justify-between mb-3"><div className="flex items-center gap-2"><span className="text-2xl">{country.flag_emoji}</span><div><h3 className="font-semibold">{country.country_name}</h3></div></div><Badge variant="secondary">{country.status}</Badge></div>
        <div className="mb-4"><div className="flex items-center justify-between text-sm mb-1"><span className="text-muted-foreground">Progress</span><span>{calculateProgress(country.checklist_progress)}%</span></div><Progress value={calculateProgress(country.checklist_progress)} className="h-2" /></div>
        <div className="flex gap-2"><Button variant="outline" size="sm" className="flex-1" onClick={() => navigate(`/visa/${country.country_id}/${country.visa_id.split('_')[1]}`)}>Details</Button><Button variant="outline" size="icon" onClick={handleDownloadPdf} disabled={isDownloading}>{isDownloading ? <Loader2 className="animate-spin h-4 w-4" /> : <Download className="h-4 w-4" />}</Button><Button variant="ghost" size="sm" onClick={() => onRemove(country.id)} className="text-destructive hover:bg-destructive/10">Remove</Button></div>
      </CardContent>
    </Card>
  );
};

export const EmptyDestinations = () => {
  const navigate = useNavigate();
  return (<Card className="border-border/50 border-dashed"><CardContent className="p-8 text-center"><MapPin className="h-12 w-12 text-muted-foreground mx-auto mb-4" /><h3 className="font-semibold mb-2">No destinations yet</h3><Button onClick={() => navigate("/results")}>Explore Options</Button></CardContent></Card>);
};